import { Avatar } from '@chakra-ui/avatar';
import { Card, CardBody, CardHeader } from '@chakra-ui/card';
import { Box, Heading, HStack, Text } from '@chakra-ui/layout'
import React from 'react'
// import "react-multi-carousel/lib/styles.css";
// import "react-multi-carousel/lib/styles.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { GrFormNext, GrFormPrevious } from 'react-icons/gr';
import testImg1 from '../../assets/image/Urvi_bf420f90f4.webp'
import testImg2 from '../../assets/image/Whats_App_Image_2021_02_03_at_10_45_59_d703e3d1cd.webp'
import testImg3 from '../../assets/image/Bhavya_20e91a056b.webp'
import testImg4 from '../../assets/image/Asther_e65b03f1d3.webp'
import testImg5 from '../../assets/image/85827864_17483e5ab2.webp'

const Testimonial = () => {
    var settings = {
        dots: true,
        infinite: true,
        autoplay: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        // initialSlide: 0,
        nextArrow: <GrFormNext color='red!important' />,
        prevArrow: <GrFormPrevious color='red!important' />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 1,
                    // infinite: true,
                    // dots: true,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    }
    return (
        <Box
            mx="auto"
            maxW="90vw"
            transition="0.5 ease-out"
            overflow="hidden"
        >
            <Text
                className='main-section'
                textAlign="center"
                color="#FB1923"
                textTransform="uppercase"
                fontWeight="bold"
                fontSize="3xl"
                letterSpacing="3px"
            >TESTIMONIALS</Text>
            <Box mx={{ base: '2', sm: '2', md: '20', lg: '20', xl: '20' }} mt={6} pb={20}>
                <Slider className='slid' {...settings}>
                            <Card rounded="1rem!important" width={{base:'100%!important',sm:'100%!important',md:'23rem!important'}} mx="auto" my={4} background="white" boxShadow="-5px 6px 29px -14px #ffbbbb" maxW='25rem' minW="20rem" p="3rem">
                                <CardBody p="0!important">
                                    <Text className='main-section' fontSize={14} lineHeight="27px">
                                        I shall always be grateful to the HelpNow team  for the quick ambulance service which helped me move my mother from my house to the hospital - after she had an accident at home - really soon. From home to the X-ray centre to hospital admission, the team was most helpful and patient.
                                    </Text>
                                </CardBody>
                                <CardHeader px="0!important">
                                    <HStack gap='4' alignItems='center'>
                                        <Avatar name='Urvi Sangoi' src={testImg1} />
                                        <Box>
                                            <Heading className='main-section' color="red" size='sm'>Urvi Sangoi</Heading>
                                            <Text className='main-section' fontSize={11}>Deputy General Manager, Reliance Industries Ltd, Mumbai</Text>
                                        </Box>
                                    </HStack>
                                </CardHeader>
                            </Card>
                            <Card rounded="1rem!important" width={{base:'100%!important',sm:'100%!important',md:'23rem!important'}} mx="auto" my={4} background="white" boxShadow="-5px 6px 29px -14px #ffbbbb" maxW='25rem' minW="20rem" p="3rem">
                                <CardBody p="0!important">
                                    <Text fontSize={14} lineHeight="27px">
                                        We wanted to go from Mulund to SRV Hospital, Chembur. We called for a HelpNow ambulance and it reached us in 15 minutes - very quick! The ride, ambulance staff and even the post ride service was very good. We had absolutely no problem.  </Text>
                                </CardBody>
                                <CardHeader px="0!important">
                                    <HStack gap='4' alignItems='center'>
                                        <Avatar name='Bhumikka Anam' src={testImg2} />
                                        <Box>
                                            <Heading className='main-section' color="red" size='sm'>Bhumikka Anam</Heading>
                                            <Text className='main-section' fontSize={11}>Manager, HR, MT Educare Ltd, Mumbai</Text>
                                        </Box>
                                    </HStack>
                                </CardHeader>
                            </Card>

                            <Card rounded="1rem!important" width={{base:'100%!important',sm:'100%!important',md:'23rem!important'}} mx="auto" my={4} background="white" boxShadow="-5px 6px 29px -14px #ffbbbb" maxW='25rem' minW="20rem" p="3rem">
                                <CardBody p="0!important">
                                    <Text fontSize={14} lineHeight="27px">
                                        We couldn’t believe it when we were told that the ambulance would reach us in a few minutes. But it actually did! The driver and doctor were very professional and shifted the patent very swiftly. We are very grateful to HelpNow for the best services we got.</Text>
                                </CardBody>
                                <CardHeader px="0!important">
                                    <HStack gap='4' alignItems='center'>
                                        <Avatar name='Bhavya Soni' src={testImg3} />
                                        <Box>
                                            <Heading className='main-section' color="red" size='sm'>Bhavya Soni</Heading>
                                            <Text className='main-section' fontSize={11}>Commercial Pilot</Text>
                                        </Box>
                                    </HStack>
                                </CardHeader>
                            </Card>

                            <Card rounded="1rem!important" width={{base:'100%!important',sm:'100%!important',md:'23rem!important'}} mx="auto" my={4} background="white" boxShadow="-5px 6px 29px -14px #ffbbbb" maxW='25rem' minW="20rem" p="3rem">
                                <CardBody p="0!important">
                                    <Text fontSize={14} lineHeight="27px">
                                        It was a very challenging moment for us when we were looking for an ambulance for our Covid positive aunt who was very critical. We are very thankful to HelpNow for immediately coming to our rescue and helping us.</Text>
                                </CardBody>
                                <CardHeader px="0!important">
                                    <HStack gap='4' alignItems='center'>
                                        <Avatar name='Asther Rathod' src={testImg4} />
                                        <Box>
                                            <Heading className='main-section' color="red" size='sm'>Asther Rathod</Heading>
                                            <Text className='main-section' fontSize={11}>HR Business Partner, Voltas Beko</Text>
                                        </Box>
                                    </HStack>
                                </CardHeader>
                            </Card>

                            <Card rounded="1rem!important" width={{base:'100%!important',sm:'100%!important',md:'23rem!important'}} mx="auto" my={4} background="white" boxShadow="-5px 6px 29px -14px #ffbbbb" maxW='25rem' minW="20rem" p="3rem">
                                <CardBody p="0!important">
                                    <Text fontSize={14} lineHeight="27px">
                                        HelpNow is a very good ambulance service, equipped with first class amenities like ICU etc. We have always used their services whenever we needed them. I recommend them highly for any medical emergency.</Text>
                                </CardBody>
                                <CardHeader px="0!important">
                                    <HStack gap='4' alignItems='center'>
                                        <Avatar name='Saira Banu' src={testImg5} />
                                        <Box>
                                            <Heading className='main-section' color="red" size='sm'>Saira Banu</Heading>
                                            <Text className='main-section' fontSize={11}>Veteran Actress & Wife of Late Actor Dilip Kumar</Text>
                                        </Box>
                                    </HStack>
                                </CardHeader>
                            </Card>
                </Slider>
            </Box>
        </Box>
    )
}

export default Testimonial